/**
 * AUTO-GENERATED — do not edit by hand.
 * Regenerated by the login-framework Vite plugin on every build and on file changes during dev.
 *
 * Source: /experimental/custom/stages/ and /experimental/custom/callbacks/
 */

import type { Component } from 'svelte';

export interface CustomRegistryEntry {
  component: Component;
  /** Props declared via `export let` in the component — only these are forwarded by the mapper. */
  acceptedProps: string[];
}

export const customStageRegistry: Record<string, CustomRegistryEntry> = {
};

export const customCallbackRegistry: Record<string, CustomRegistryEntry> = {
};
